import tcesdk from '@tencent/tce-sdk';
import LangConfig from './local';

export default {
  t: function (path) {
    var pathArr = path.split(".");
    var value = "";
    var currentLang = LangConfig[tcesdk.language.getCurrentLang()];

    for (var i = 0, len = pathArr.length; i < len; i++) {
      value = currentLang[pathArr[i]];
      if (i === len - 1) {
        return value;
      }
      if (!value) {
        return "";
      }
      currentLang = value;
    }

    return "";
  }
}
